import { render, staticRenderFns } from "./BloodResultProvidersIndexComponent.vue?vue&type=template&id=09271373"
import script from "./BloodResultProvidersIndexComponent.vue?vue&type=script&lang=js"
export * from "./BloodResultProvidersIndexComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports